import { IMessage, INpcInfoWithExtra } from '..';
import BaseStorageService from './base';

const CHAT_HISTOTY_STORAGE_KEY = 'chat_history';
// const USER_INFO_STORAGE_KEY = 'user_info';

/**
 * chat_history存储格式
 * {
 *   [user_id]: {
 *     [npc_id]: {
 *        npc_info: INpcMetaInfo[],
 *        message_list: IMessage[],
 *     }
 *   }
 * }
 */

class ChatStorage extends BaseStorageService {
  setLocalChatHistory(data: {
    userId: number;
    npcId: number;
    npcInfo?: INpcInfoWithExtra;
    messageList?: IMessage[];
  }) {
    const { userId, npcId, messageList = [], npcInfo } = data;
    let obj = this.getItem(CHAT_HISTOTY_STORAGE_KEY);

    if (obj) {
      if (obj[userId]?.[npcId]) {
        obj[userId][npcId].message_list = messageList;
        npcInfo && (obj[userId][npcId].npc_info = npcInfo);
      } else if (obj[userId]) {
        obj[userId][npcId] = {
          message_list: messageList,
          npc_info: npcInfo || {},
        };
      } else {
        obj[userId] = {
          [npcId]: {
            message_list: messageList,
            npc_info: npcInfo || {},
          },
        };
      }
    } else {
      obj = {
        [userId]: {
          [npcId]: {
            message_list: messageList,
            npc_info: npcInfo,
          },
        },
      };
    }

    this.setItem(CHAT_HISTOTY_STORAGE_KEY, obj);
  }

  getLocalChatHistory(userId: number, npcId?: number) {
    if (!userId) return;

    const history = this.getItem(CHAT_HISTOTY_STORAGE_KEY);
    if (!history) return null;
    if (npcId) {
      return history[userId]?.[npcId]?.message_list;
    } else {
      // 返回全部
      return history[userId];
    }
  }

  clearLocalChatHistory(userId: number) {
    if (userId) {
      const history = this.getItem(CHAT_HISTOTY_STORAGE_KEY);
      if (history) {
        delete history[userId];
        this.setItem(CHAT_HISTOTY_STORAGE_KEY, history);
      }
    } else {
      this.removeItem(CHAT_HISTOTY_STORAGE_KEY);
    }
  }
}

export default ChatStorage;
